<template>
    <div class="pc-banner flex-center">
        <div class="left-trans">
            <div class="animation-area flex-between-stright">
                <img
                    src="../../../assets/img/computer/henxian-zuo.gif"
                    class="line-left"
                />
                <img
                    src="../../../assets/img/computer/box.png"
                    class="box-left"
                />
                <div class="circle-area">
                    <img
                        src="../../../assets/img/computer/cicle-out.png"
                        class="left-out-cicle"
                    />
                    <img
                        src="../../../assets/img/computer/cicle-inner.png"
                        class="left-inner-cicle"
                    />
                </div>
            </div>
        </div>
        <div class="middle-content">
            <div class="search-box">
                <h1>{{ name }}区块链浏览器</h1>
                <div class="search-component">
                    <input
                        type="text"
                        class="search-input"
                        placeholder="地址/哈希/区块高度"
                        v-model="value"
                        @keyup.enter="search(value)"
                    />
                    <div class="search-btn" @click="search(value)">搜索</div>
                </div>
            </div>
        </div>
        <div class="right-trans">
            <div class="animation-area flex-between-stright">
                <div class="circle-area">
                    <img
                        src="../../../assets/img/computer/cicle-out.png"
                        class="right-out-cicle"
                    />
                    <img
                        src="../../../assets/img/computer/cicle-inner.png"
                        class="right-inner-cicle"
                    />
                </div>
                <img
                    src="../../../assets/img/computer/box.png"
                    class="box-right"
                />
                <img
                    src="../../../assets/img/computer/henxian-you.gif"
                    class="line-right"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { search } from "@/mixins/search";
import { ref } from "vue";

const name = process.env.VUE_APP_PROJECT_TITLE;
let value = ref("");
</script>

<style lang="scss" scoped>
.pc-banner {
    height: 556px;
    min-width: 1250px;
    background: $banner_bg;
    // overflow: hidden;
    .search-box {
        width: 729px;
        margin: 220px auto 0;
        text-align: center;
        h1 {
            font-size: 56px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
            color: $white;
            line-height: 74px;
        }
        .search-component {
            margin-top: 41px;
            position: relative;
            .search-input {
                width: 729px;
                height: 50px;
                background: $white;
                border-radius: 39px;
                border: none;
                font-size: 16px;
                padding: 0 150px 0 22px;
                color: #838b9e;
            }
            .search-btn {
                position: absolute;
                right: 3px;
                top: 3px;
                width: 132px;
                height: 44px;
                line-height: 44px;
                background: linear-gradient(90deg, #6265e3 0%, #4246cd 100%);
                border-radius: 39px;
                font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: $white;
                cursor: pointer;
                transition: 0.3s;
            }
            .search-btn:hover {
                opacity: 0.9;
            }
            .search-btn:active {
                opacity: 1;
            }
        }
    }
    .left-trans,
    .middle-content,
    .right-trans {
        display: inline-block;
        height: 556px;
    }
    .left-trans {
        width: 275px;
        background: url("../../../assets/img/computer/left-line.png") no-repeat
            top 62px right 205px;
        overflow: hidden;
        flex-shrink: 1;
        .animation-area {
            position: relative;
            margin-top: 60px;
            height: 450px;
            width: 100px;
            float: right;
            right: 39px;
        }
        .box-left {
            margin-top: -40px;
            margin-left: -40px;
            animation: jump 2s ease-in-out 1s infinite alternate;
        }
        .circle-area {
            position: relative;
            width: 91px;
            height: 91px;
            .left-out-cicle {
                position: absolute;
                left: 0;
                top: 0;
                animation: clockwise 2.5s linear infinite;
            }
            .left-inner-cicle {
                width: 70px;
                position: absolute;
                left: 10px;
                top: 11px;
                animation: anticlockwise 2.5s linear infinite;
            }
        }
    }
    .middle-content {
        position: relative;
        width: 1200px;
        flex-shrink: 0;
        background: url("../../../assets/img/computer/ball.png") center center
            no-repeat;
    }
    .right-trans {
        width: 275px;
        background: url("../../../assets/img/computer/right-line.png") no-repeat
            top 62px left 205px;
        overflow: hidden;
        flex-shrink: 1;
        .animation-area {
            position: relative;
            margin-top: 60px;
            height: 450px;
            width: 100px;
            float: left;
            left: 40px;
        }
        .box-right {
            // margin-top: 30px;
            margin-right: -30px;
            animation: jump 2s ease-in-out 0.1s infinite alternate;
        }
        .circle-area {
            position: relative;
            width: 91px;
            height: 91px;
            .right-out-cicle {
                position: absolute;
                left: 0;
                top: 0;
                animation: clockwise 2.5s linear infinite;
            }
            .right-inner-cicle {
                width: 70px;
                position: absolute;
                left: 10px;
                top: 12px;
                animation: anticlockwise 2.5s linear infinite;
            }
        }
    }
}
// 动画区
@keyframes clockwise {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes anticlockwise {
    0% {
        transform: rotate(360deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

@keyframes jump {
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(0, 15px);
    }
}
</style>
